import { referrerActions } from '@/redux/modules';
import * as Styles from './ReferrerFriend.styles';
import React, {
  useCallback, useEffect, useRef, useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import useLocale from '@/hooks/useLocale';
import Loader from '@/components/Layout/Loader';
import FaqReferrer from '@/components/FrequentlyQuestions/FaqReferrer';
import HowItWorks from './HowItWorks';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { FOXTROT_REFER_EARN } from '@/config/GrowthBook/constants';
import { ExtolePostMessageDescription } from './ReferrerFriend.enum';

const parsePostMessageData = (raw) => {
  if (raw == null) return null;
  if (typeof raw === 'object' && !Array.isArray(raw)) return raw;
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return null;
};

const ReferrerFriend = () => {
  const { referrerFriend: referrerLocale } = useLocale();
  const [accordionsOpened, setAccordionsOpened] = useState(null);
  const [extoleIframeHeight, setExtoleIframeHeight] = useState(null);
  const dispatch = useDispatch();
  const history = useHistory();
  const { routes: routesLocale } = useLocale();
  const extoleJwt = useSelector(state => state.referrer.extoleJwt);
  const hasError = extoleJwt && extoleJwt.error;
  const isLoading = extoleJwt && extoleJwt.loading;
  const enableReferEarn = useFeatureIsOn(FOXTROT_REFER_EARN);
  const extoleIframeRef = useRef(null);

  const callGetExtoleJwt = useCallback(() => {
    dispatch(referrerActions.referrer.extoleJwt.get());
  }, [dispatch]);

  useEffect(() => {
    if (hasError || !enableReferEarn) {
      history.push(routesLocale.home);
    }
  }, [hasError, history, routesLocale, enableReferEarn]);

  useEffect(() => {
    if (!extoleJwt.value && enableReferEarn) {
      callGetExtoleJwt();
    }
  }, [callGetExtoleJwt, extoleJwt.value, enableReferEarn]);

  useEffect(() => {
    const handleMessage = (event) => {
      const iframeWindow = extoleIframeRef.current?.contentWindow;
      if (!iframeWindow || event.source !== iframeWindow) {
        return;
      }

      const data = parsePostMessageData(event.data);
      if (
        data
        && data.description === ExtolePostMessageDescription.IFRAME_HEIGHT
        && typeof data.height === 'number'
        && data.height > 0
      ) {
        setExtoleIframeHeight(data.height);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  if (isLoading) {
    return <Loader data-testid="loader" />;
  }

  return (
    <Styles.Wrapper data-testid="referrer-friend">
      <Styles.ExtoleIframe
        ref={extoleIframeRef}
        $height={extoleIframeHeight}
        scrolling="no"
        src={`https://indique-um-amigo.hostgator.com.br/zones/account_page_embedded_experience?extole_jwt=${extoleJwt.value}`}
      />
      <HowItWorks
        title={referrerLocale.howItWorks.title}
        linkLabel={referrerLocale.howItWorks.linkLabel}
        linkUrl={referrerLocale.howItWorks.linkUrl}
        steps={referrerLocale.howItWorks.steps}
      />
      <FaqReferrer
        title={referrerLocale.faq.title}
        faqItems={referrerLocale.faq.items}
        accordionsOpened={accordionsOpened}
        setAccordionsOpened={setAccordionsOpened}
      />
    </Styles.Wrapper>
  );
};

export default ReferrerFriend;
